export default __webpack_public_path__ + "1f83ea1e54ee11c500fafcfd20ece450.png";